export default class Modal {
    triggers = [];
    modal;
    bodyClasses;
    otherInstance;
    isOpen = false;

    constructor(modalSelector, triggerSelector, bodyClasses = false, modalInstanceToCloseOnOpen = false) {
        this.modal = document.querySelector(modalSelector);
        if (!this.modal) {
            throw new Error('No modal found.')
        }
        this.triggers = document.querySelectorAll(triggerSelector);
        if (!this.triggers.length) {
            throw new Error('No trigger found.')
        }
        this.bodyClasses = bodyClasses;
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleModal()
            })
        });
        this.otherInstance = modalInstanceToCloseOnOpen;
        document.body.addEventListener('click', (event) => {
            if (!event.target.closest(modalSelector) && !event.target.classList.contains(modalSelector) && this.isOpen) {
                this.closeModal();
            }
        });
    }

    toggleModal() {
        if (this.isOpen) {
            if (this.bodyClasses) {
                document.body.classList.remove(...this.bodyClasses);
            }
            this.modal.classList.remove('open');
            this.triggers.forEach(trigger=> trigger.classList.remove('active'));
            this.isOpen = false;
        } else {
            if (this.otherInstance) {
                this.otherInstance.closeModal();
            }
            if (this.bodyClasses) {
                document.body.classList.add(...this.bodyClasses);
            }
            this.modal.classList.add('open');
            this.triggers.forEach(trigger=> trigger.classList.add('active'));
            this.isOpen = true;
        }
    }

    closeModal() {
        if (this.isOpen) {
            if (this.bodyClasses) {
                document.body.classList.remove(...this.bodyClasses);
            }
            this.modal.classList.remove('open');
            this.triggers.forEach(trigger=> trigger.classList.remove('active'));
            this.isOpen = false;
        }
    }

}